import { useState, useEffect, memo } from "react";
import { useLocation } from "react-router-dom";
import ReviewSuccessAttendee from "../Screens/ReviewSuccessAttendee";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { getDeviceInfoDetails } from "../utils/PlatformCheck";
import axios from "axios";
import { CallBackGivenForDismiss } from "../utils/AppUtils";
import { AmplitudeAddLog } from "../utils/AppAmplitude";

function FeedbackHost() {
  const location = useLocation();
  const [audioRating, setAudioRating] = useState();
  const [videoRating, setVideoRating] = useState();
  const [textFeedback, setTextFeedback] = useState("");
  const [hoveredAudioRating, setHoveredAudioRating] = useState(0);
  const [hoveredVideoRating, setHoveredVideoRating] = useState(0);
  const [reviewPostSuccess, setReviewPostSuccess] = useState(false);
  const [discardCallCheck, setDiscardCallCheck] = useState("");
  const deviceInfoDetails = getDeviceInfoDetails();

  const {
    __merchantId,
    __userId,
    appInsightTrack,
    setInformationContent,
    setShowInformationStrip,
    grp,
    role,
    businessURL,
    __appConfirmUniqueID,
    setCheckOutUrl,
    setIsPaid,
    webUrlSubDomain,
    apiUrlPost,
    setAppointmentId,
    setCustomerId
  } = useLiveStreamAppContext();

  const headers = {
    "Content-Type": "application/json",
    userId: __userId,
    merchantId: __merchantId,
  };

  //useEffect for handling Session End
  useEffect(() => {
    sessionStorage.setItem("end", 1);

    const searchParams = new URLSearchParams(location.search);
    const discardCall = searchParams.get('hostDiscard') || 'false';
    setDiscardCallCheck(discardCall === 'true');
  }, [location.search]);

  //Function for Handling Rating Stars on Click
  const handleRatingClick = (type, rating) => {
    if (type === "video") {
      setVideoRating(rating);
      setHoveredVideoRating(0);
    } else if (type === "audio") {
      setAudioRating(rating);
      setHoveredAudioRating(0);
    }
  };

  const handleMouseOver = (type, rating) => {
    if (type === "video") {
      setHoveredVideoRating(rating);
    } else if (type === "audio") {
      setHoveredAudioRating(rating);
    }
  };
  const handleMouseOut = (type) => {
    if (type === "video") {
      setHoveredVideoRating(0);
    } else if (type === "audio") {
      setHoveredAudioRating(0);
    }
  };

  //Function to Validate Feedback attributes and Call Feedback Api
  const submitFeedback = () => {
    if (!audioRating || !videoRating) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'warn',
        message: 'All reviews are mandatory.',
      });
      return;
    }

    let trimmedtextFeedback = textFeedback.trim();

    if ((audioRating <= 3 || videoRating <= 3) && trimmedtextFeedback.length < 20) {
      setShowInformationStrip(true);
      setInformationContent({
        type: 'warn',
        message: 'Required Minimum 20 Characters.'
      })
      return;
    }

    let sendFeedback = document.getElementById("sendFeedback");
    sendFeedback.classList.add("divDisabled");

    const feedbackinitialize = async () => {
      const payload = {
        attendeeType: 2,
        rnkVideo: videoRating,
        rnkAudio: audioRating,
        deviceInfoDetails: deviceInfoDetails,
        appConfirmUniqueId: __appConfirmUniqueID,
        qualityFeedback: textFeedback,
      };
      try {
        const feedbackResponse = await axios.post(
          `${apiUrlPost}managelivestreamfeedback`,
          payload, { headers }
        );
        // Dispose or reset sensitive data after use
        payload.attendeeType = null;
        payload.rnkVideo = null;
        payload.rnkAudio = null;
        payload.deviceInfoDetails = null;
        payload.qualityFeedback = null;
        const response = feedbackResponse.data.data;
        if (response.isSuccess === true) {
          if (response.isPaid === false) {
            setIsPaid(false);
            setAppointmentId(response.appointmentId);
            setCustomerId(response.customerId);
            const urlParams = new URLSearchParams(window.location.search);
            let calendarVersion = urlParams.get("cal") ?? "";
            let customerParam = "";
            if (calendarVersion.length > 0) {
              calendarVersion = "/" + calendarVersion
              customerParam = "&CustomerID=" + response.customerId;
            }
            setCheckOutUrl(webUrlSubDomain.replace("www", grp) + 'merchants/checkout' + calendarVersion + '?' + response.appointmentDetails + customerParam);
            setReviewPostSuccess(true);
          } else {
            setIsPaid(true)
            setReviewPostSuccess(true);
          }
        }
      } catch (error) {
        console.error("Error initializing:", error);
        appInsightTrack(__merchantId, __userId, "Feedback Host", "", error);
      }
    };
    feedbackinitialize().then(() => {
      sendFeedback.classList.remove("divDisabled");
    });
  };
  const handleCloseWindow = () => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 115, grp, __appConfirmUniqueID);
    setTimeout(() => {
      CallBackGivenForDismiss();
      if (deviceInfoDetails.isMobileApp && !deviceInfoDetails.isAndroid) {
        try {
          window.close();
        } catch (e) {
          appInsightTrack(__merchantId, __userId, "Feedback Host Dismiss", "", e);
        }
        window.location.href = role === "Presenter" ? 'closewindowpro://closewindowProURL' : 'closewindow://closewindowURL';
      } else {
        window.close();
      }
    }, 1500);
  };
  useEffect(() => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 110, grp, __appConfirmUniqueID);
  }, [__userId])

  useEffect(() => {
    sessionStorage.setItem("end", 1)
  }, [])
  return (
    <>
      {!reviewPostSuccess === true ? (
        <div className="host-review" style={{ display: "flex" }}>
          <div className="host-review-wrapper">
            <div className="center-Review-Screen no-wrap">
              {discardCallCheck && (
                <div className="save-video-review" style={{ display: "block" }}>
                  <div className="saving-vdo-icon">
                    <i className="icon font-awesome-solid-pro va-check-circle"></i>
                  </div>
                  <h5 className="review-title">Saved Video to Vagaro Drive</h5>
                  <p className="review-txt">
                    You can navigate away from this browser.
                  </p>
                </div>
              )}
              <div className="save-video-review" id="skipVideoSaveReview">
                <h5 className="review-title">How Was The Live Stream?</h5>
              </div>
              <div className="rating-dives">
                <div className="stars">
                  <div className="your-review-title">Video Quality:</div>
                  <div className="font-size24">
                    <div className="review-rating" id="dv-videoqualityhost">
                      {[1, 2, 3, 4, 5].map((value) => (
                        <div
                          key={value}
                          className={`rating-symbol glyphicon glyphicon-star ${videoRating >= value || hoveredVideoRating >= value
                            ? "rating-symbol"
                            : "glyphicon-star-empty"
                            }`}
                          onMouseOut={() => handleMouseOut("video")}
                          onMouseOver={() => handleMouseOver("video", value)}
                          onClick={() => handleRatingClick("video", value)}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="stars">
                  <div className="your-review-title audioQualityTitle">Audio Quality:</div>
                  <div className="font-size24">
                    <div className="review-rating" id="dv-audioquality">
                      {[1, 2, 3, 4, 5].map((value) => (
                        <div
                          key={value}
                          className={`rating-symbol glyphicon glyphicon-star ${audioRating >= value || hoveredAudioRating >= value
                            ? "rating-symbol"
                            : "glyphicon-star-empty"
                            }`}
                          onMouseOut={() => handleMouseOut("audio")}
                          onMouseOver={() => handleMouseOver("audio", value)}
                          onClick={() => handleRatingClick("audio", value)}
                        ></div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="host-Imp">
                <div
                  className="lbl-TxtArea"
                  style={{
                    display:
                      audioRating < 4 || videoRating < 4 ? "block" : "none",
                  }}
                >
                  <div className="rightReviewCountText">
                    <span>{textFeedback.length}</span>/500
                  </div>
                  <label className="field-label spname lt-text">
                    Additional feedback:
                  </label>
                  <textarea
                    className="review-text-field w-input inputfixscroll bg-Txt t-height"
                    placeholder="What can be improved?"
                    maxLength="500"
                    value={textFeedback}
                    onChange={(e) => setTextFeedback(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="ft-btn">
              <button
                className="cbtn brd-btn dismiss"
                onClick={handleCloseWindow}
              >
                <span>Done</span>
              </button>
              <button
                id="sendFeedback"
                className="cbtn thm-btn send-feedback"
                onClick={submitFeedback}
              >
                <span>Send Feedback</span>
              </button>
            </div>
          </div>
        </div>
      ) : (
        <ReviewSuccessAttendee />
      )}
    </>
  );
}
export default memo(FeedbackHost);